if ( typeof ShowMoreArrow !== 'function' ) {

	class ShowMoreArrow extends HTMLElement {

		constructor(){
			super();
			this.init();	
		}

		init() {

			const toggle = this.querySelector('.js-show-more');	
			const panelHeight = toggle.nextElementSibling.scrollHeight;
			clearTimeout(this.transitionTimeout);
			toggle.nextElementSibling.style.removeProperty('max-height');

			toggle.classList.remove('active', 'disabled');
			toggle.parentElement.classList.remove('disabled', 'show-more--active-not-active');
			toggle.removeAttribute('aria-hidden');
			toggle.removeAttribute('tabindex');
			toggle.removeEventListener('click', this.onClickHandler);
			
			const setExpanded = (expanded) => {
				toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
				const label = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
				if ( label ) toggle.setAttribute('aria-label', label);
			};
			setExpanded(false);

			this.onClickHandler = e=>{
				clearTimeout(this.transitionTimeout);
				const panel = e.currentTarget.nextElementSibling;
				if ( ! e.currentTarget.classList.contains('active') ) {
					setExpanded(true);
					e.currentTarget.classList.add("active");
					panel.style.maxHeight = `${panel.scrollHeight}px`;
					this.transitionTimeout = setTimeout(()=>{
						panel.style.maxHeight = `initial`;
					}, 510);
				} else {
					setExpanded(false);
					e.currentTarget.classList.remove("active");
					panel.style.maxHeight = `${panel.scrollHeight}px`;
					this.transitionTimeout = setTimeout(()=>{
						panel.style.maxHeight = `var(--height)`;
					}, 10);
				}
			}

			const collapsedHeight = parseFloat(getComputedStyle(toggle.nextElementSibling).maxHeight);
			if ( panelHeight <= collapsedHeight + 10 ) {
				toggle.classList.add("active", "disabled");
				toggle.parentElement.classList.add('show-more--active-not-active', "disabled");
				// nothing to expand: hide the toggle from assistive tech
				toggle.setAttribute('aria-hidden', 'true');
				toggle.setAttribute('tabindex', '-1');
				setExpanded(true);

			} else {
				toggle.addEventListener('click', this.onClickHandler);
				// a11y: expand when keyboard focus moves into the truncated (hidden) content
				if ( ! this._focusHandler ) {
					this._focusHandler = () => {
						if ( ! toggle.classList.contains('active') ) {
							toggle.click();
						}
					};
					toggle.nextElementSibling.addEventListener('focusin', this._focusHandler);
				}
			}

			toggle.classList.add('init');

		}

	}

  if ( typeof customElements.get('show-more-arrow') == 'undefined' ) {
    customElements.define('show-more-arrow', ShowMoreArrow);
	}

}